import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getCookieValue } from 'src/util/Common';
import IntlMessages from '../../util/IntlMessages';
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL
} from '../../constants/ThemeSetting';

const { SubMenu } = Menu;

class HorizontalNav extends Component {
  getNavStyleSubMenuClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return 'gx-menu-horizontal gx-submenu-popup-curve';
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return 'gx-menu-horizontal gx-submenu-popup-curve gx-inside-submenu-popup-curve';
      case NAV_STYLE_BELOW_HEADER:
        return 'gx-menu-horizontal gx-submenu-popup-curve gx-below-submenu-popup-curve';
      case NAV_STYLE_ABOVE_HEADER:
        return 'gx-menu-horizontal gx-submenu-popup-curve gx-above-submenu-popup-curve';
      default:
        return 'gx-menu-horizontal';
    }
  };

  render() {
    const { pathname, navStyle } = this.props;
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = selectedKeys.split('/')[1];
    return (
      <Menu
        defaultOpenKeys={[defaultOpenKeys]}
        mode="horizontal"
        selectedKeys={[selectedKeys]}
      >

        <SubMenu
          key="main"
          className={this.getNavStyleSubMenuClass(navStyle)}
          title={<IntlMessages id="sidebar.main" />}
        >
          <Menu.Item key="sample">
            <Link
              to={getCookieValue('defaultUrl') ? getCookieValue('defaultUrl') : '/he-thong/quyen'}
            >
              <i className="icon icon-widgets" />
              <IntlMessages id="sidebar.samplePage" />
            </Link>
          </Menu.Item>
        </SubMenu>
      </Menu>

    );
  }
}

HorizontalNav.propTypes = {
  pathname: PropTypes.string,
  navStyle: PropTypes.string
};

HorizontalNav.defaultProps = {
  pathname: '',
  navStyle: ''
};

const mapStateToProps = ({ settings }) => {
  const {
    themeType, navStyle, pathname, locale
  } = settings;
  return {
    themeType, navStyle, pathname, locale
  };
};
export default connect(mapStateToProps)(HorizontalNav);
